export interface RenewPasswordRequest {
  email: string;
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export const renewPasswordRequestOutputTransformer = (
  req: RenewPasswordRequest,
) => ({
  email: req.email,
  old_password: req.oldPassword,
  new_password: req.newPassword,
});

export const getEmptyRenewPasswordRequest = (): RenewPasswordRequest => ({
  email: '',
  oldPassword: '',
  newPassword: '',
  confirmPassword: '',
});
